module.exports = __webpack_public_path__ + "img/12.ee9e63c7.png";